import { render, staticRenderFns } from "./hotelNav.vue?vue&type=template&id=ca1b2142&scoped=true"
import script from "./hotelNav.vue?vue&type=script&lang=js"
export * from "./hotelNav.vue?vue&type=script&lang=js"
import style0 from "./hotelNav.vue?vue&type=style&index=0&id=ca1b2142&lang=sass"
import style1 from "./hotelNav.vue?vue&type=style&index=1&id=ca1b2142&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1b2142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1b2142')) {
      api.createRecord('ca1b2142', component.options)
    } else {
      api.reload('ca1b2142', component.options)
    }
    module.hot.accept("./hotelNav.vue?vue&type=template&id=ca1b2142&scoped=true", function () {
      api.rerender('ca1b2142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hotelNav.vue"
export default component.exports